import React, { useEffect, useState, useContext, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import { toast, ToastContainer } from "react-toastify";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FaRegFilePdf } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function StudentCorrectionPageXI() {
  const navigate = useNavigate();

  const { state } = useLocation();
  const candidateData = state?.studentData || null;

  const photographRef = useRef();
  const signatureRef = useRef();
  const casteRef = useRef();
  const divyangRef = useRef();

  const [photoFile, setPhotoFile] = useState(null);
  const [signFile, setSignFile] = useState(null);
  const [casteFile, setCasteFile] = useState(null);
  const [divyangFile, setDivyangFile] = useState(null);

  const [photoBase64, setPhotoBase64] = useState("");
  const [photoName, setPhotoName] = useState("");
  const [photourl, setPhotourl] = useState("");

  const [signBase64, setSignBase64] = useState("");
  const [signName, setSignName] = useState("");
  const [signurl, setSignurl] = useState("");

  const [casteBase64, setCasteBase64] = useState("");
  const [casteName, setCasteName] = useState("");
  const [casteurl, setCasteurl] = useState("");

  const [divyangBase64, setDivyangBase64] = useState("");
  const [divyangName, setDivyangName] = useState("");
  const [divyangurl, setDivyangurl] = useState("");

  const [showCropper, setShowCropper] = useState(false);
  const [cropperImage, setCropperImage] = useState("");
  const cropperRef = useRef(null);

  const [additionalfiltersubj, setAdditionalfiltersubj] = useState([]);

  const [olddivyangFile, setOlddivyangFile] = useState(null);

  const [optional1, setOptional1] = useState("");
  const [optional2, setOptional2] = useState("");
  const [artselective, setArtselective] = useState("");

  const [before2010, setBefore2010] = useState("");

  const [selectedSubjectNames, setSelectedSubjectNames] = useState({
    coresubject: "",
    matribhasa: "",
    // compulsory_one: "",
    // compulsory_two: "",
    additionalsubject: "",
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
    optional1: "",
    optional2: "",
    artselective: "",
  });

  const [selectedArtsSubjects, setSelectedArtsSubjects] = useState({
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [compulsory, setCompulsory] = useState([]);
  const [optionalsubj, setOptionalsubj] = useState([]);
  const [additionalsubj, setAdditionalsubj] = useState([]);
  const [optionalfiltersubj, setOptionalfiltersubj] = useState([]);
  const [compulsoryonename, setCompulsoryonename] = useState("");
  const [compulsorytwoname, setCompulsorytwoname] = useState("");
  const [artsSubjects, setArtsSubjects] = useState([]);
  const [coresubject, setCoresubject] = useState([]);
  const [matribhasa, setMatribhasa] = useState([]);
  const [electivefiltersubj, setElectivefiltersubj] = useState([]);

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [exregularornot, setExRegularOrNot] = useState(false);

  const [formData, setFormData] = useState({
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    apaar_id: "",
    section_val: "",
    roll_no: "",
    clasS_ROLL_NO: "",
    stream: "",
    coresubject: "",
    matribhasa: "",
    compulsory_one: "",
    compulsory_two: "",
    additionalsubject: "",
    medium_of_exam: "",
    // pen_no: "",
  });
  const handleArtsOptionalChange = (e) => {
    const { name, value } = e.target;

    setSelectedArtsSubjects((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    // ✅ Hindi restrictions
    if (
      formData.coresubject === "HNA" &&
      (formData.additionalsubject === "HIN" || artselective === "HIN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "HIN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }
    if (formData.coresubject === "HNA" && artselective === "HIN") {
      setArtselective("");
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
    }
    // ✅ English restrictions
    if (
      formData.coresubject === "ENA" &&
      (formData.additionalsubject === "ENG" ||
        formData.additionalsubject === "FEN" ||
        artselective === "ENG" ||
        artselective === "FEN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "ENG" || artselective === "FEN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }

    // ✅ Science stream restrictions
    if (formData.stream === "SCIENCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Commerce stream restrictions
    if (formData.stream === "COMMERCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Arts stream restrictions
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "MAT" ||
        arts_optional_two === "MAT" ||
        arts_optional_three === "MAT"
      ) {
        if (
          formData.additionalsubject === "MAT" ||
          formData.additionalsubject === "STA"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }

      // If STA selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "STA" ||
        arts_optional_two === "STA" ||
        arts_optional_three === "STA"
      ) {
        if (
          formData.additionalsubject === "STA" ||
          formData.additionalsubject === "MAT"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }
    }
  }, [
    formData.coresubject,
    formData.stream,
    formData.additionalsubject,
    optional1,
    optional2,
    selectedArtsSubjects,
  ]);

  useEffect(() => {
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT is selected anywhere → reset STA from additional subject
      if (
        (arts_optional_one === "MAT" ||
          arts_optional_two === "MAT" ||
          arts_optional_three === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA is selected anywhere → reset MAT from additional subject
      if (
        (arts_optional_one === "STA" ||
          arts_optional_two === "STA" ||
          arts_optional_three === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [
    formData.stream,
    formData.additionalsubject,
    selectedArtsSubjects.arts_optional_one,
    selectedArtsSubjects.arts_optional_two,
    selectedArtsSubjects.arts_optional_three,
  ]);

  useEffect(() => {
    // 🔹 Science stream MAT–STA restrictions
    if (formData.stream === "SCIENCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be STA
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }

    // 🔹 Commerce stream MAT–CAE restrictions
    if (formData.stream === "COMMERCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be CAE
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If CAE chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [formData.stream, formData.additionalsubject, optional1, optional2]);

  useEffect(() => {
    setLoading(true);

    if (!candidateData) {
      navigate("/intermediate-admin-dashboard");
      return;
    }

    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const coreSubjects = getSessionData("coreSubjects") || [];
    const matri_BhasaSubjects = getSessionData("matri_BhasaSubjects") || [];
    const compulsory_Paper_2Subjects =
      getSessionData("compulsory_Paper_2Subjects") || [];
    const additional_Subjects = getSessionData("additional_Subjects") || [];
    const elective_Subjects = getSessionData("electivesubj") || [];
    const optional_Paper_1_2Subjects =
      getSessionData("optional_Paper_1_2Subjects") || [];
    const cL11EndDate = getSessionData("cL11EndDate") || {};

    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteList(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setCoresubject(Array.isArray(coreSubjects) ? coreSubjects : []);
    setMatribhasa(
      Array.isArray(matri_BhasaSubjects) ? matri_BhasaSubjects : [],
    );
    setCompulsory(
      Array.isArray(compulsory_Paper_2Subjects)
        ? compulsory_Paper_2Subjects
        : [],
    );
    setAdditionalsubj(
      Array.isArray(additional_Subjects) ? additional_Subjects : [],
    );
    setOptionalsubj(
      Array.isArray(optional_Paper_1_2Subjects)
        ? optional_Paper_1_2Subjects
        : [],
    );
    setElectivefiltersubj(
      Array.isArray(elective_Subjects) ? elective_Subjects : [],
    );
    // ✅ Subject filtering based on student stream
    const stream = candidateData?.stream || "";

    const rawAadhaar = candidateData?.aadhaR_CARD || "";
    const digitsOnly = rawAadhaar.replace(/\D/g, "").slice(0, 12);
    const formattedAadhaar = digitsOnly.replace(
      /(\d{4})(\d{4})(\d{1,4})?/,
      (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" "),
    );

    const filteredCompulsory =
      compulsory_Paper_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL",
      ) || [];

    const filteredOptional =
      optional_Paper_1_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL",
      ) || [];

    const filteredAdditional =
      additional_Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL",
      ) || [];
    if (stream === "SCIENCE" || stream === "COMMERCE") {
      const [firstComp, secondComp] = filteredCompulsory;
      setCompulsoryonename(firstComp?.subjecT_NAME || "");
      setCompulsorytwoname(secondComp?.subjecT_NAME || "");

      setFormData((prev) => ({
        ...prev,
        compulsory_one: firstComp?.subjecT_ID || "",
        compulsory_two: secondComp?.subjecT_ID || "",
      }));

      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);

      setOptional1(candidateData.subjecT_4_CODE || "");
      setOptional2(candidateData.subjecT_5_CODE || "");
    } else if (stream === "ARTS") {
      setArtsSubjects(filteredCompulsory);
      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);
      setSelectedArtsSubjects({
        arts_optional_one: candidateData.subjecT_3_CODE || "",
        arts_optional_two: candidateData.subjecT_4_CODE || "",
        arts_optional_three: candidateData.subjecT_5_CODE || "",
      });
      setArtselective(candidateData.subjecT_2_CODE || "");
    }
    setFormData((prev) => ({
      ...prev,
      candidate_name: candidateData.candidatE_NAME || "",
      board_name: candidateData.boarD_NAME || "",
      gender: candidateData.gender || "",
      date_of_birth: candidateData.dob || "",
      fathers_name: candidateData.fatheR_NAME || "",
      mothers_name: candidateData.motheR_NAME || "",
      religion: candidateData.religion || "",
      nationality: "Indian",
      aadhaar_no: formattedAadhaar || "",
      divyang_val: candidateData.divyang || "",
      caste_val: candidateData.cast || "",
      area: candidateData?.area || "",
      state_val: candidateData?.state || "",
      district_val: candidateData?.districT_ID || "",
      block_val: candidateData?.block || "",
      address_val: candidateData?.address || "",
      pin_no: candidateData?.pincode || "",
      contact_no: candidateData?.contacT_NO || "",
      email_id: candidateData?.emaiL_ID || "",
      category_choice: candidateData.studenT_EXAM_CATEGORY_DESCRIPTION || "",
      section_val: candidateData.section || "",
      clasS_ROLL_NO: candidateData.clasS_ROLL_NO || "",
      stream: candidateData.stream || "",
      coresubject: candidateData.subjecT_1_A_CODE || "",
      matribhasa: candidateData.subjecT_1_B_CODE || "",
      additionalsubject: candidateData.subjecT_6_CODE || "",
      apaar_id: candidateData.apaaR_ID || "",
      medium_of_exam: candidateData.mediuM_OF_EXAM || "",
      // pen_no: class11otherstudent.peN_NO || "",
    }));
    setBefore2010(candidateData.beforE_2010_STATUS || "");
    setPhotoName(candidateData.studenT_PHOTOGRAPH || "");
    setSignName(candidateData.studenT_SIGNATURE || "");
    setCasteName(candidateData.castE_CERTIFICATE || "");
    setDivyangName(candidateData.divyanG_CERTIFICATE || "");
    setPhotourl(candidateData.studenT_PHOTOGRAPH_URL || "");
    setSignurl(candidateData.studenT_SIGNATURE_URL || "");
    setCasteurl(candidateData.castE_CERTIFICATE_URL || "");
    setDivyangurl(candidateData.divyanG_CERTIFICATE_URL || "");
    setOlddivyangFile(candidateData.divyanG_CERTIFICATE || "");
    setExRegularOrNot(
      candidateData.studenT_EXAM_CATEGORY_DESCRIPTION === "EX-REGULAR"
        ? true
        : false,
    );
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // Formatting logic
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }

    if (name === "aadhaar_no") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      formattedValue = digitsOnly.replace(
        /(\d{4})(\d{4})(\d{1,4})?/,
        (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" "),
      );
    }
    if (name === "section_val") {
      setFormData((prev) => ({
        ...prev,
        section_val: value,
        clasS_ROLL_NO: "", // reset class roll no
      }));
    }
    if (name === "category_choice") {
      setFormData((prev) => ({
        ...prev,
        category_choice: formattedValue,
        stream: "",
        section_val: "",
        clasS_ROLL_NO: "",
      }));
    }
    // if (name === "apaar_id") {
    //   formattedValue = value
    //     .replace(/\D/g, "")
    //     .slice(0, 12)
    //     .replace(/(\d{4})(?=\d)/g, "$1  ")
    //     .trim();
    // }

    if (name === "contact_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    if (name === "pin_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 6);
    }
    // if (name === "pen_no") {
    //   formattedValue = value.replace(/\D/g, "");
    // }

    if (name === "clasS_ROLL_NO") {
      formattedValue = value.replace(/\D/g, "");
    }

    if (name === "address_val") {
      formattedValue = value.replace(/[^a-zA-Z0-9 ,]/g, "");
    }

    if (name === "email_id") {
      formattedValue = value.toLowerCase().replace(/[^a-z0-9@._]/g, "");
    }
    // if (name === "pen_no") {
    //   formattedValue = value.replace(/\D/g, "");
    // }
    if (name === "apaar_id") {
      formattedValue = value.replace(/\D/g, "");
    }
    // Dependent dropdown handling
    if (name === "state_val") {
      setFormData((prev) => ({
        ...prev,
        state_val: formattedValue,
        district_val: "", // reset district
        block_val: "", // reset block
      }));
    } else if (name === "district_val") {
      setFormData((prev) => ({
        ...prev,
        district_val: formattedValue,
        block_val: "", // reset block
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }

    // Clear validation errors on input change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleArtsSubjects = () => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    // Include ARTS + ALL
    const filtered = compulsory.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL",
    );
    setArtsSubjects(filtered);

    const filteredOptional = optionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL",
    );
    const filteredadditional = additionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL",
    );
    setAdditionalfiltersubj(filteredadditional);
    setOptionalfiltersubj(filteredOptional);
  };

  const handlePreview = async () => {
    setLoading(true);

    const trimmed = (val) => (val || "").trim();
    const rawAadhaar = formData.aadhaar_no?.trim();
    if (candidateData.entrY_FORM != "EX_REGULAR") {
      if (rawAadhaar) {
        const aadhaarNumber = rawAadhaar.replace(/\s/g, "");
        if (aadhaarNumber && aadhaarNumber.length === 12) {
          const token = sessionStorage.getItem("intermediateAdminToken");
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/AadharNoCheckingStudentData_CL11`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateData.candidatE_ID || "",
                  aadhaR_CARD: aadhaarNumber,
                }),
              },
            );
            const result = await response.json();
            if (result.data === "Duplicate") {
              Swal.fire({
                icon: "warning",
                title: "Aadhaar Number Already Exists For Other Candidate.",
              });
              setFormData((prev) => ({
                ...prev,
                aadhaar_no: "",
              }));
              setLoading(false);
              return;
            }
          } catch (error) {
            console.error("Error verifying Aadhaar:", error);
            setLoading(false);
            return;
          }
        }
      }
    }
    // const rawPen = formData.pen_no?.trim();
    // if (rawPen) {
    //   const penno = rawPen.replace(/\s/g, "");
    //   if (penno && penno.length >= 11 && penno.length <= 14) {
    //     const token = sessionStorage.getItem("tokenclassxi");
    //     try {
    //       const response = await fetch(
    //         `${config.API_BASE_URL}/PENNoCheckingStudentData_CL11`,
    //         {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
    //             Authorization: `Bearer ${token}`,
    //           },
    //           body: JSON.stringify({
    //             candidatE_ID: class11candidateid || "",
    //             peN_NO: penno,
    //           }),
    //         }
    //       );
    //       const result = await response.json();
    //       if (result.status === 404) {
    //         Swal.fire({
    //           icon: "warning",
    //           title:
    //             "PEN (Permanent Education Number) No. Already Exists For Other Candidate.",
    //         });
    //         setFormData((prev) => ({
    //           ...prev,
    //           pen_no: "",
    //         }));
    //         setLoading(false);
    //         return;
    //       }
    //     } catch (error) {
    //       console.error("Error verifying PEN No.", error);
    //       setLoading(false);
    //       return;
    //     }
    //   }
    // }
    if (candidateData.entrY_FORM != "EX_REGULAR") {
      const rawroll = formData.roll_no?.trim();
      if (rawroll) {
        const roll = rawroll.replace(/\s/g, "");
        if (roll) {
          const token = sessionStorage.getItem("intermediateAdminToken");
          try {
            const response = await fetch(
              `${config.API_BASE_URL}/SchoolSectionWiseRollNoChecking_CL11`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  candidatE_ID: candidateData.candidatE_ID || "",
                  section: formData.section_val || "",
                  clasS_ROLL_NO: roll || "",
                }),
              },
            );
            const result = await response.json();
            if (result.data === "Duplicate") {
              Swal.fire({
                icon: "warning",
                title: "This Roll No. Already Exists In This Section.",
              });
              setFormData((prev) => ({
                ...prev,
                section_val: "",
                roll_no: "",
              }));
              setLoading(false);
              return;
            }
          } catch (error) {
            console.error("Error verifying Roll No.", error);
            setLoading(false);
            return;
          }
        }
      }
    }
    const newErrors = {};
    const candidateName = trimmed(formData.candidate_name);
    const fathersName = trimmed(formData.fathers_name);
    const mothersName = trimmed(formData.mothers_name);
    setTimeout(() => {
      // Validation logic here (abbreviated for brevity)
      if (!formData.gender) newErrors.gender = "Gender is required.";
      if (!formData.date_of_birth)
        newErrors.date_of_birth = "Date of Birth is required.";

      if (candidateName) {
        if (
          fathersName &&
          mothersName &&
          candidateName.toLowerCase() === fathersName.toLowerCase() &&
          candidateName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.candidate_name =
            "Candidate name cannot be the same as Father's and Mother's name.";
          newErrors.fathers_name =
            "Father's name cannot be the same as Candidate and Mother's name.";
          newErrors.mothers_name =
            "Mother's name cannot be the same as Candidate and Father's name.";
          toast.error(
            "All names are the same! Candidate, Father's name, and Mother's name cannot be the same.",
          );
        } else {
          if (
            fathersName &&
            candidateName.toLowerCase() === fathersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Father's name.";
            newErrors.fathers_name =
              "Father's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Father's name.",
            );
          }
          if (
            mothersName &&
            candidateName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Mother's name.",
            );
          }
          if (
            fathersName &&
            mothersName &&
            fathersName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.fathers_name =
              "Father's name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Father's name.";
            toast.error(
              "Duplicate names! Father's name cannot be the same as Mother's name.",
            );
          }
        }
      }
      if (!formData.mothers_name)
        newErrors.mothers_name = "Mother Name is required.";
      if (!formData.fathers_name)
        newErrors.fathers_name = "Father Name is required.";
      if (!formData.divyang_val)
        newErrors.divyang_val = "Divyang selection is required.";
      if (!formData.caste_val) newErrors.caste_val = "Caste is required.";
      if (!formData.religion) newErrors.religion = "Religion is required.";
      if (candidateData.entrY_FORM != "EX_REGULAR") {
        const aadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");
        if (!aadhaar) {
          newErrors.aadhaar_no = "Aadhaar number is required.";
        } else if (!/^\d{12}$/.test(aadhaar)) {
          newErrors.aadhaar_no = "Aadhaar number must be 12 digits.";
        }

        if (!formData.area) newErrors.area = "Area is required.";
        if (!trimmed(formData.state_val))
          newErrors.state_val = "State is required.";
        if (!trimmed(formData.district_val))
          newErrors.district_val = "District is required.";
        if (!trimmed(formData.block_val))
          newErrors.block_val = "Block is required.";
        if (!trimmed(formData.address_val))
          newErrors.address_val = "Address is required.";

        if (!trimmed(formData.pin_no)) {
          newErrors.pin_no = "Pin code is required.";
        } else if (!/^\d{6}$/.test(formData.pin_no)) {
          newErrors.pin_no = "Pin code must be 6 digits.";
        }

        if (!trimmed(formData.contact_no)) {
          newErrors.contact_no = "Contact number is required.";
        } else if (!/^\d{10}$/.test(formData.contact_no)) {
          newErrors.contact_no = "Contact number must be 10 digits.";
        }

        if (
          formData.email_id &&
          !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email_id)
        ) {
          newErrors.email_id = "Invalid email format.";
        }
      }
      if (!formData.stream) newErrors.stream = "Stream is required.";
      if (formData.caste_val !== "CS_001" && !casteName) {
        newErrors.caste_certificate_name = "caste certificate is required";
      }

      if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
        // More validations for streams and subjects, as in your code...
        if (!formData.coresubject) {
          newErrors.coresubject = "Core Language is Required.";
        }
        if (formData.coresubject === "HNB") {
          if (!formData.matribhasa) {
            newErrors.matribhasa = "Matri Bhasa is Required.";
          }
        }
        if (!optional1) {
          newErrors.sc_optional_one = "Optional 1 is Required.";
        }
        if (!optional2) {
          newErrors.sc_optional_two = "Optional 2 is Required.";
        }
      }
      if (formData.stream === "ARTS") {
        if (!formData.coresubject) {
          newErrors.coresubject = "Core Language is Required.";
        }
        if (formData.coresubject === "HNB") {
          if (!formData.matribhasa) {
            newErrors.matribhasa = "Matri Bhasa is Required.";
          }
        }
        if (!selectedArtsSubjects.arts_optional_one) {
          newErrors.arts_optional_one = "Optional 1 is Required.";
        }
        if (!selectedArtsSubjects.arts_optional_two) {
          newErrors.arts_optional_two = "Optional 2 is Required.";
        }
        if (!selectedArtsSubjects.arts_optional_three) {
          newErrors.arts_optional_three = "Optional 3 is Required.";
        }
        if (!artselective) {
          newErrors.arts_elective_one = "Elective Language is Required.";
        }
      }

      // Other validations...

      // const apaar = (formData.apaar_id || "").replace(/\D/g, "");
      // if (apaar && !/^\d{12}$/.test(apaar))
      //   newErrors.apaar_id = "APAAR ID must be 12 digits.";
      // if (!formData.pen_no) {
      //   newErrors.pen_no = "PEN No. is required.";
      // }
      // const pen_no = (formData.pen_no || "").replace(/\D/g, "");
      // if (pen_no && !/^\d{11,14}$/.test(pen_no)) {
      //   newErrors.pen_no = "PEN No. must be between 11 to 14 digits.";
      // }
      if (candidateData.entrY_FORM != "EX_REGULAR") {
        if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
          newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
        }

        if (formData.category_choice === "REGULAR") {
          if (!formData.section_val) {
            newErrors.section_val = "Section is required.";
          }
        }
      }
      // if (!trimmed(formData.roll_no))
      //   newErrors.roll_no = "Class roll number is required.";

      // Duplicate subject check
      // const subjectFields = [
      //   formData.language_one,
      //   formData.language_two,
      //   formData.compulsory_one,
      //   formData.compulsory_two,
      //   formData.compulsory_three,
      //   formData.additional_subject,
      // ];

      // const counts = subjectFields.reduce((acc, subj) => {
      //   if (subj) {
      //     acc[subj] = (acc[subj] || 0) + 1;
      //   }
      //   return acc;
      // }, {});

      // const duplicates = Object.keys(counts).filter((subj) => counts[subj] > 1);
      // if (duplicates.length > 0) {
      //   Swal.fire(
      //     "Duplicate Subject Detected",
      //     `The subject "${duplicates[0]}" is selected multiple times. Each subject must be unique.`,
      //     "error"
      //   );
      //   setLoading(false);
      //   return;
      // }
      setErrors(newErrors);
      const noErrors = Object.keys(newErrors).length === 0;
      if (!noErrors) {
        const firstErrorKey = Object.keys(newErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorKey}"]`,
        );
        if (firstErrorElement) {
          firstErrorElement.focus();
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsPreviewed(true);
      }
      setLoading(false);
    }, 500);
  };

  const handleSetCompulsorySubjects = (selectedStream) => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    if (!Array.isArray(compulsory)) return;
    if (!Array.isArray(optionalsubj)) return;
    if (!Array.isArray(additionalsubj)) return;

    // Include selected stream + ALL
    const filteredSubjects = compulsory.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL",
    );
    const filteredOptionalSubjects = optionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL",
    );
    const filteredadditionalSubjects = additionalsubj.filter(
      (subject) =>
        subject.streams === selectedStream || subject.streams === "ALL",
    );

    setAdditionalfiltersubj(filteredadditionalSubjects);
    setOptionalfiltersubj(filteredOptionalSubjects);

    const [firstSubject, secondSubject] = filteredSubjects;
    setCompulsoryonename(firstSubject?.subjecT_NAME || "");
    setCompulsorytwoname(secondSubject?.subjecT_NAME || "");

    setFormData((prev) => ({
      ...prev,
      compulsory_one: firstSubject?.subjecT_ID || "",
      compulsory_two: secondSubject?.subjecT_ID || "",
    }));
  };
  const handleRollBlur = async () => {
    const rawroll = formData.clasS_ROLL_NO?.trim();
    if (rawroll) {
      const rollno = rawroll.replace(/\s/g, "");

      if (!rollno) return;

      const token = sessionStorage.getItem("intermediateAdminToken");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/SchoolSectionWiseRollNoChecking_CL11`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData.candidatE_ID || "",
              section: formData.section_val || "",
              clasS_ROLL_NO: rollno,
            }),
          },
        );

        const result = await response.json();
        console.log(result.data);
        if (result.data === "Duplicate") {
          Swal.fire({
            icon: "warning",
            title: "This Roll No. Already Exists In This Section.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            section_val: "",
            clasS_ROLL_NO: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying rollno:", error);
      }
    }
  };
  const handleButtonClick = () => {
    handleSubmit();
  };
  const handleSubmit = async () => {
    const token = sessionStorage.getItem("intermediateAdminToken");
    const cleanAadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    // Convert Buffer/File → Base64
    const convertToBase64 = (file) =>
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
    if (formData.divyang_val === "DIV_001") {
      setDivyangFile(null);
      setOlddivyangFile("");
      setDivyangName("");
    }

    const PHOTO_CHANGE = photoFile ? "YES" : "NO";
    const SIGN_CHANGE = signFile ? "YES" : "NO";
    const CASTE_CHANGE = casteFile ? "YES" : "NO";
    const DIVYANG_CHANGE = divyangFile ? "YES" : "NO";

    const photoBase64Final = photoFile
      ? await convertToBase64(photoFile)
      : photoBase64;

    const signBase64Final = signFile
      ? await convertToBase64(signFile)
      : signBase64;

    const casteBase64Final = casteFile
      ? await convertToBase64(casteFile)
      : casteBase64;

    const divyangBase64Final = divyangFile
      ? await convertToBase64(divyangFile)
      : divyangBase64;
    // Old file names from backend API
    const oldPhotoName = candidateData.studenT_PHOTOGRAPH || "";
    const oldSignName = candidateData.studenT_SIGNATURE || "";
    const oldcasteFile = candidateData.castE_CERTIFICATE || "";
    let divyangNameFinal;
    let casteNameFinal;
    /* FILE NAMES (IF NEW FILE → NEW NAME, ELSE OLD NAME) */
    const studentPhotoName = photoFile ? photoName : oldPhotoName;
    const studentSignName = signFile ? signName : oldSignName;
    if (formData.divyang_val === "DIV_001") {
      divyangNameFinal = "";
    } else {
      divyangNameFinal = divyangFile ? divyangName : olddivyangFile;
    }
    if (formData.caste_val === "CS_001") {
      casteNameFinal = "";
    } else {
      casteNameFinal = casteFile ? casteName : oldcasteFile;
    }
    // const casteNameFinal = casteFile ? casteName : oldcasteFile;

    const fd = new FormData();
    fd.append("SCHOOL_DIST", candidateData.schooL_DISTRICT || "");
    fd.append("SCHOOL_CODE", candidateData.schooL_CODE || "");
    fd.append("CANDIDATE_CODE", candidateData.candidatE_ID || "");
    fd.append("CANDIDATE_NAME", formData.candidate_name || "");
    fd.append("DOB", formData.date_of_birth || "");
    fd.append("DIVYANG", formData.divyang_val || "");
    fd.append("FATHER_NAME", formData.fathers_name || "");
    fd.append("MOTHER_NAME", formData.mothers_name || "");
    fd.append("RELIGION", formData.religion || "");
    fd.append("CAST", formData.caste_val || "");
    fd.append("APAAR_ID", formData.apaar_id || "");
    fd.append("SECTION", formData.section_val || "");
    fd.append("CLASS_ROLL_NO", formData.clasS_ROLL_NO || "");
    fd.append("NATIONALITY", formData.nationality || "INDIAN");
    fd.append("AADHAR_CARD", cleanAadhaar || "");
    fd.append("MEDIUM_ID", formData.medium_of_exam || "");
    fd.append("AREA", formData.area || "");
    fd.append("STATE", formData.state_val || "");
    fd.append("DISTRICT_ID", formData.district_val || "");
    fd.append("BLOCK", formData.block_val || "");
    fd.append("ADDRESS", formData.address_val || "");
    fd.append("PINCODE", formData.pin_no || "");
    fd.append("CONTACT_NO", formData.contact_no || "");
    fd.append("EMAIL_ID", formData.email_id || "");

    // fd.append("category_choice", formData.category_choice || "");
    // fd.append("board_name", formData.board_name || "");

    if (formData.stream === "SCIENCE" || formData.stream === "COMMERCE") {
      fd.append("SUBJECT_1_A_TYPE", "CL");
      fd.append("SUBJECT_1_A_CODE", formData.coresubject || "");
      fd.append("SUBJECT_1_B_TYPE", "MB");
      fd.append("SUBJECT_1_B_CODE", formData.matribhasa || "");
      fd.append("SUBJECT_2_TYPE", "C1");
      fd.append("SUBJECT_2_CODE", formData.compulsory_one || "");
      fd.append("SUBJECT_3_TYPE", "C2");
      fd.append("SUBJECT_3_CODE", formData.compulsory_two || "");
      fd.append("SUBJECT_4_TYPE", "O1");
      fd.append("SUBJECT_4_CODE", optional1 || "");
      fd.append("SUBJECT_5_TYPE", "O2");
      fd.append("SUBJECT_5_CODE", optional2 || "");
      fd.append("SUBJECT_6_TYPE", "AL");
      fd.append("SUBJECT_6_CODE", formData.additionalsubject || "");
    } else {
      fd.append("SUBJECT_1_A_TYPE", "CL");
      fd.append("SUBJECT_1_A_CODE", formData.coresubject || "");
      fd.append("SUBJECT_1_B_TYPE", "MB");
      fd.append("SUBJECT_1_B_CODE", formData.matribhasa || "");
      fd.append("SUBJECT_2_TYPE", "EL");
      fd.append("SUBJECT_2_CODE", artselective || "");
      fd.append("SUBJECT_3_TYPE", "O1");
      fd.append("SUBJECT_3_CODE", selectedArtsSubjects.arts_optional_one || "");
      fd.append("SUBJECT_4_TYPE", "O2");
      fd.append("SUBJECT_4_CODE", selectedArtsSubjects.arts_optional_two || "");
      fd.append("SUBJECT_5_TYPE", "O3");
      fd.append(
        "SUBJECT_5_CODE",
        selectedArtsSubjects.arts_optional_three || "",
      );
      fd.append("SUBJECT_6_TYPE", "AL");
      fd.append("SUBJECT_6_CODE", formData.additionalsubject || "");
    }

    // File names
    fd.append("STUDENT_PHOTOGRAPH", studentPhotoName || "");
    fd.append("STUDENT_SIGNATURE", studentSignName || "");
    fd.append("DIVYANG_CERTIFICATE", divyangNameFinal || "");
    fd.append("CASTE_CERTIFICATE", casteNameFinal || "");
    // Actual file objects
    fd.append("STUDENT_PHOTOGRAPH_FILE", photoFile || "");
    fd.append("STUDENT_SIGNATURE_FILE", signFile || "");
    fd.append("DIVYANG_CERTIFICATE_FILE", divyangFile || "");
    fd.append("CASTE_CERTIFICATE_FILE", casteFile || "");
    // Change status flags
    fd.append("STUDENT_PHOTOGRAPH_CHANGE_STS", PHOTO_CHANGE);
    fd.append("STUDENT_SIGNATURE_CHANGE_STS", SIGN_CHANGE);
    fd.append("DIVYANG_CERTIFICATE_CHANGE_STS", DIVYANG_CHANGE);
    fd.append("CASTE_CERTIFICATE_CHANGE_STS", CASTE_CHANGE);
    fd.append("UPDATE_BY", sessionStorage.getItem("schoolCode") || "");
    // console.log(candidateData);
    fd.append("REGISTRATION_NO", candidateData.registratioN_NO || "");

    //  console.log([...fd.entries()]);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminUpdateDataStudentRegistration_CL11`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: fd,
        },
      );

      const data = await response.json();

      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Demography details updated Successfully",
        });

        navigate("/intermediate-demographic-details-update-xi");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };
  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    // setCandidateid12(candidateid12 || "");
    // setCastecode12(formData.caste_val || "");
    // setDivyangcode12(formData.divyang_val || "");
  };
  // Document related functions
  const validateFile = (file, type) => {
    const validTypes =
      type === "image"
        ? ["image/jpeg", "image/jpg"]
        : ["application/pdf"];

    const minSize = type === "image" ? 10 * 1024 : 30 * 1024; // 10KB / 30KB
    const maxSize = type === "image" ? 40 * 1024 : 300 * 1024; // 40KB / 300KB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text:
          type === "image"
            ? "Please upload a JPG or JPEG image."
            : "Please upload a PDF file.",
      });
      return false;
    }

    if (file.size < minSize || file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "Invalid File Size",
        text:
          type === "image"
            ? "Image size must be between 10KB and 40KB."
            : "PDF size must be between 30KB and 300KB.",
      });
      return false;
    }

    return true;
  };

  const handleChange2 = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = ["photograph", "signature"].includes(type)
      ? "image"
      : "pdf";

    const isValid = validateFile(file, fileType);

    if (!isValid) {
      if (type === "photograph" && photographRef.current)
        photographRef.current.value = "";
      if (type === "signature" && signatureRef.current)
        signatureRef.current.value = "";
      if (type === "caste" && casteRef.current) casteRef.current.value = "";
      if (type === "divyang" && divyangRef.current)
        divyangRef.current.value = "";
      return;
    }

    if (type === "photograph") setPhotoFile(file);
    if (type === "signature") setSignFile(file);
    if (type === "caste") setCasteFile(file);
    if (type === "divyang") setDivyangFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      let base64 = reader.result;
      const cleanBase64 = base64.replace(/\s/g, "");

      if (type === "photograph") {
        setPhotoBase64(cleanBase64);
        setPhotoName(file.name);
        setCropperImage(cleanBase64);
        setShowCropper(true);
      }

      if (type === "signature") {
        setSignBase64(cleanBase64);
        setSignName(file.name);
      }

      if (type === "caste") {
        setCasteBase64(cleanBase64);
        setCasteName(file.name);
      }

      if (type === "divyang") {
        setDivyangBase64(cleanBase64);
        setDivyangName(file.name);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData((prev) => ({
        ...prev,
        date_of_birth: `${dd}-${mm}-${yyyy}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, date_of_birth: "" }));
    }
  };
  const handleCropCancel = () => {
    setShowCropper(false); // close cropper modal
    setPhotoFile(null);
    setPhotoBase64("");
    // setPhotoName("");
    setCropperImage(""); // reset cropper image

    // Reset file input so user can select again
    if (photographRef.current) {
      photographRef.current.value = "";
    }
    setTimeout(() => {
      setPhotoFile(null);
      setCropperImage("");
    }, 0);
  };
  const handleCropConfirm = async () => {
    if (!cropperRef.current) return;

    const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas({
      width: 300,
      height: 400,
    });

    // Convert cropped canvas to base64
    const croppedDataUrl = croppedCanvas.toDataURL("image/jpeg");
    const img = new Image();
    img.src = croppedDataUrl;

    img.onload = async () => {
      try {
        // Step 1: validate original cropped image

        // if (aistatus === "ON") {
        //   await validatePhotograph(img);
        // }
        // Step 2: convert AFTER validation
        const grayImg = await convertToGrayscale(img);

        // Step 3: Save grayscale base64
        setPhotoBase64(grayImg.src);

        // Step 4: Save file name
        setPhotoName(photoFile?.name || "cropped-photo.jpg");

        // 🔹 Step 5: Convert cropped canvas into File object and set it
        croppedCanvas.toBlob((blob) => {
          if (blob) {
            const croppedFile = new File(
              [blob],
              photoFile?.name || "cropped-photo.jpg",
              {
                type: "image/jpeg",
              },
            );
            setPhotoFile(croppedFile);
          }
        }, "image/jpeg");

        setShowCropper(false);
      } catch (err) {
        toast.error(err.message);
      }
    };
  };
  function convertToGrayscale(img) {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const avg = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
        data[i] = data[i + 1] = data[i + 2] = avg;
      }
      ctx.putImageData(imageData, 0, 0);
      const grayDataUrl = canvas.toDataURL("image/jpeg");
      const grayImg = new Image();
      grayImg.src = grayDataUrl;
      grayImg.onload = () => resolve(grayImg);
    });
  }
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!validateFile(file, "image")) {
      if (photographRef.current) photographRef.current.value = "";
      return;
    }

    setPhotoFile(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setCropperImage(reader.result); // show original image in cropper
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };
  const handleAadhaarBlur = async () => {
    const rawAadhaar = formData.aadhaar_no?.trim();
    if (rawAadhaar) {
      const aadhaarNumber = rawAadhaar.replace(/\s/g, "");

      if (!aadhaarNumber || aadhaarNumber.length !== 12) return;

      const token = sessionStorage.getItem("intermediateAdminToken");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/AadharNoCheckingStudentData_CL11`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData.candidatE_ID || "",
              aadhaR_CARD: aadhaarNumber,
            }),
          },
        );

        const result = await response.json();
        console.log(result.data);
        if (result.data === "Duplicate") {
          Swal.fire({
            icon: "warning",
            title: "Aadhaar Number Already Exists For Other Candidate.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            aadhaar_no: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying Aadhaar:", error);
      }
    }
  };
  return (
    <>
      <div class="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Student Demographic
                      Details Correction for Class XI
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/intermediate-admin-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active">
                        {" "}
                        Demographic Details Correction for Class XI
                      </li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Name of Student{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled={isPreviewed || exregularornot}
                                    className={`form-control form-control-sm ${errors.candidate_name ? "is-invalid" : ""
                                      }`}
                                    name="candidate_name"
                                    placeholder="Cadidate Name"
                                    value={formData.candidate_name}
                                    onChange={handleChange}
                                  />
                                  {errors.candidate_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.candidate_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <select
                                  className="form-select form-select-sm"
                                  name="gender"
                                  disabled
                                  onChange={handleChange}
                                  value={formData.gender?.toUpperCase()}
                                >
                                  <option value="">Select</option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <DatePicker
                                  minDate={new Date(1975, 0, 1)}
                                  maxDate={
                                    candidateData.beforE_2010_STATUS === "NO"
                                      ? new Date(2012, 2, 1)
                                      : new Date()
                                  }
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                        const [dd, mm, yyyy] =
                                          formData.date_of_birth.split("-");
                                        return new Date(
                                          Number(yyyy),
                                          Number(mm) - 1,
                                          Number(dd),
                                        );
                                      })()
                                      : null
                                  }
                                  onChange={handleChangeDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${errors.date_of_birth ? "is-invalid" : ""
                                    }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled={isPreviewed || exregularornot}
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                                {errors.date_of_birth && (
                                  <div className="text-danger mt-1 small">
                                    {errors.date_of_birth}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Father’s Name{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="fathers_name"
                                    disabled={isPreviewed || exregularornot}
                                    className={`form-control form-control-sm ${errors.fathers_name ? "is-invalid" : ""
                                      }`}
                                    value={formData.fathers_name}
                                    onChange={handleChange}
                                  />
                                </div>
                                {errors.fathers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.fathers_name}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Mother’s Name{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mothers_name"
                                    onChange={handleChange}
                                    disabled={isPreviewed || exregularornot}
                                    className={`form-control form-control-sm ${errors.mothers_name ? "is-invalid" : ""
                                      }`}
                                    value={formData.mothers_name}
                                  />
                                </div>
                                {errors.mothers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.mothers_name}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                              <div class="form-group  mb-3">
                                <label>
                                  Religion{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <select
                                    className="form-select form-select-sm"
                                    name="religion"
                                    id="religion"
                                    value={formData.religion || ""}
                                    onChange={handleChange}
                                    disabled={isPreviewed || exregularornot}
                                  >
                                    <option value="">Select</option>
                                    {religionList.map((religion) => (
                                      <option
                                        key={religion.religioN_ID}
                                        value={religion.religioN_ID}
                                      >
                                        {religion.religioN_NAME}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Nationality</label>
                                <select
                                  class="form-select form-control disable"
                                  id="nationality"
                                  disabled
                                >
                                  <option value="Indian" selected="">
                                    Indian
                                  </option>
                                </select>
                              </div>
                            </div>
                            {candidateData.entrY_FORM != "EX_REGULAR" && (
                              <div class="col-lg-4 col-md-6">
                                <div class="form-group  mb-3">
                                  <label>
                                    Student Aadhaar Number{" "}
                                    <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className={`form-control form-control-sm ${errors.aadhaar_no ? "is-invalid" : ""
                                      }`}
                                    name="aadhaar_no"
                                    maxLength="14" // 12 digits + 2 spaces
                                    placeholder="Enter Aadhaar Number"
                                    value={formData.aadhaar_no}
                                    onChange={handleChange}
                                    onBlur={handleAadhaarBlur}
                                    disabled={isPreviewed}
                                  />

                                  {errors.aadhaar_no && (
                                    <div className="text-danger mt-1 small">
                                      {errors.aadhaar_no}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            {candidateData.entrY_FORM === "EX_REGULAR" && (
                              <div class="col-lg-4 col-md-12">
                                <div class="form-group mb-3">
                                  <label>Medium of Examination</label>
                                  <select
                                    style={{ color: "black" }}
                                    className="form-control form-control-sm"
                                    value={formData.medium_of_exam}
                                    disabled
                                  >
                                    <option value="">Select</option>
                                    {mediumList.map((medium) => (
                                      <option
                                        key={medium.mediuM_ID}
                                        value={medium.mediuM_ID}
                                      >
                                        {medium.mediuM_NAME}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}
                            {candidateData.entrY_FORM === "EX_REGULAR" && (
                              <div class="col-lg-4 col-m-6">
                                <div class="form-group mb-3">
                                  <label>
                                    Area{" "}
                                    {candidateData.entrY_FORM !=
                                      "EX_REGULAR" && (
                                        <span class="text-danger">*</span>
                                      )}
                                  </label>
                                  <select
                                    className={`form-select form-control-sm  ${errors.area ? "is-invalid" : ""
                                      }`}
                                    name="area"
                                    id="area"
                                    value={formData.area}
                                    onChange={handleChange}
                                    disabled={isPreviewed || exregularornot}
                                  >
                                    <option value="">Choose Area</option>
                                    <option value="RURAL">RURAL</option>
                                    <option value="URBAN">URBAN</option>
                                  </select>
                                  {errors.area && (
                                    <div className="text-danger mt-1 small">
                                      {errors.area}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang{" "}
                              {candidateData.entrY_FORM != "EX_REGULAR" && (
                                <span class="text-danger">*</span>
                              )}
                            </label>
                            <select
                              className={`form-select form-select-sm ${errors.divyang_val ? "is-invalid" : ""
                                }`}
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              disabled={isPreviewed || exregularornot}
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Caste{" "}
                              {candidateData.entrY_FORM != "EX_REGULAR" && (
                                <span class="text-danger">*</span>
                              )}
                            </label>
                            <select
                              className={`form-select form-select-sm ${errors.caste_val ? "is-invalid" : ""
                                }`}
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                              // disabled={!(fieldsMissing.caste && !isPreviewed)}
                              disabled={isPreviewed || exregularornot}
                            >
                              <option value="">Choose Caste</option>
                              {casteList.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.caste_val && (
                              <div className="text-danger mt-1 small">
                                {errors.caste_val}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {candidateData.entrY_FORM != "EX_REGULAR" && (
                  <div class="col-lg-12 mb-4 stretch-card">
                    <div class="card">
                      <div class="card-header card-green">
                        <h4 class="mb-0 p-2">Permanent Address</h4>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div
                            class="col-lg-9 col-m-12"
                            style={{ borderRight: "1px solid #CED4DA" }}
                          >
                            <div class="row">
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group mb-3">
                                  <label>
                                    Area <span class="text-danger">*</span>
                                  </label>
                                  <select
                                    className={`form-select form-control-sm  ${errors.area ? "is-invalid" : ""
                                      }`}
                                    name="area"
                                    id="area"
                                    value={formData.area}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  >
                                    <option value="">Choose Area</option>
                                    <option value="RURAL">RURAL</option>
                                    <option value="URBAN">URBAN</option>
                                  </select>
                                  {errors.area && (
                                    <div className="text-danger mt-1 small">
                                      {errors.area}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div className="form-group mb-3">
                                  <label>
                                    State <span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    name="state_val"
                                    id="state_val"
                                    options={stateList.map((state) => ({
                                      value: state.statE_CODE,
                                      label: state.statE_NAME,
                                    }))}
                                    value={
                                      formData.state_val
                                        ? {
                                          value: formData.state_val,
                                          label:
                                            stateList.find(
                                              (s) =>
                                                s.statE_CODE ===
                                                formData.state_val,
                                            )?.statE_NAME || "",
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChange({
                                        target: {
                                          name: "state_val",
                                          value: selectedOption?.value || "",
                                        },
                                      })
                                    }
                                    isDisabled={isPreviewed}
                                    classNamePrefix={
                                      errors.state_val
                                        ? "react-select is-invalid"
                                        : "react-select"
                                    }
                                  />
                                  {errors.state_val && (
                                    <div className="text-danger mt-1 small">
                                      {errors.state_val}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group mb-3">
                                  <label>
                                    District <span class="text-danger">*</span>
                                  </label>
                                  <Select
                                    name="district_val"
                                    id="district_val"
                                    options={districtList
                                      .filter(
                                        (d) =>
                                          d.statE_CODE === formData.state_val,
                                      )
                                      .map((district) => ({
                                        value: district.districT_CODE,
                                        label: district.district,
                                      }))}
                                    value={
                                      formData.district_val
                                        ? {
                                          value: formData.district_val,
                                          label:
                                            districtList.find(
                                              (d) =>
                                                d.districT_CODE ===
                                                formData.district_val,
                                            )?.district || "",
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChange({
                                        target: {
                                          name: "district_val",
                                          value: selectedOption?.value || "",
                                        },
                                      })
                                    }
                                    isDisabled={
                                      isPreviewed || !formData.state_val
                                    }
                                    classNamePrefix={
                                      errors.district_val
                                        ? "react-select is-invalid"
                                        : "react-select"
                                    }
                                  />
                                  {errors.district_val && (
                                    <div className="text-danger mt-1 small">
                                      {errors.district_val}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group mb-3">
                                  <label>
                                    Block <span class="text-danger">*</span>
                                  </label>
                                  <Select
                                    name="block_val"
                                    id="block_val"
                                    options={blockList
                                      .filter(
                                        (b) =>
                                          b.disT_CODE === formData.district_val,
                                      )
                                      .map((block) => ({
                                        value: block.blocK_ID,
                                        label: block.blocK_NAME,
                                      }))}
                                    value={
                                      formData.block_val
                                        ? {
                                          value: formData.block_val,
                                          label:
                                            blockList.find(
                                              (b) =>
                                                b.blocK_ID ===
                                                formData.block_val,
                                            )?.blocK_NAME || "",
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChange({
                                        target: {
                                          name: "block_val",
                                          value: selectedOption?.value || "",
                                        },
                                      })
                                    }
                                    isDisabled={
                                      isPreviewed || !formData.district_val
                                    }
                                    classNamePrefix={
                                      errors.block_val
                                        ? "react-select is-invalid"
                                        : "react-select"
                                    }
                                  />
                                  {errors.block_val && (
                                    <div className="text-danger mt-1 small">
                                      {errors.block_val}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-9 col-m-6">
                                <div class="form-group mb-3">
                                  <label>
                                    Address <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="address_val"
                                    className={`form-control form-control-sm  ${errors.address_val ? "is-invalid" : ""
                                      }`}
                                    maxlength="300"
                                    placeholder="Enter Your Address"
                                    value={formData.address_val.toUpperCase()}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  />
                                  {errors.address_val && (
                                    <div className="text-danger mt-1 small">
                                      {errors.address_val}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-lg-3 col-m-6">
                                <div class="form-group mb-3">
                                  <label>
                                    Pin Code <span class="text-danger">*</span>
                                  </label>
                                  <input
                                    autoComplete="off"
                                    type="text"
                                    className={`form-control form-control-sm ${errors.pin_no ? "is-invalid" : ""
                                      }`}
                                    name="pin_no"
                                    maxLength="6"
                                    placeholder="Enter Your Pincode"
                                    value={formData.pin_no}
                                    onChange={handleChange}
                                    disabled={isPreviewed}
                                  />
                                  {errors.pin_no && (
                                    <div className="text-danger mt-1 small">
                                      {errors.pin_no}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-12">
                            <div class="row">
                              <div class="form-group mb-3 col-m-6">
                                <label>
                                  Contact Number{" "}
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  autoComplete="off"
                                  type="text"
                                  id="contact_no"
                                  name="contact_no"
                                  className={`form-control form-control-sm ${errors.contact_no ? "is-invalid" : ""
                                    }`}
                                  maxlength="10"
                                  placeholder="Student Contact Number"
                                  value={formData.contact_no}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                />
                                {errors.contact_no && (
                                  <div className="text-danger mt-1 small">
                                    {errors.contact_no}
                                  </div>
                                )}
                              </div>
                              <div class="form-group mb-3 col-m-6">
                                <label>Email ID</label>
                                <input
                                  type="email"
                                  name="email_id"
                                  className={`form-control form-control-sm  ${errors.email_id ? "is-invalid" : ""
                                    }`}
                                  maxlength="50"
                                  placeholder="Email ID"
                                  value={formData.email_id}
                                  onChange={handleChange}
                                  disabled={isPreviewed}
                                />
                                {errors.email_id && (
                                  <div className="text-danger mt-1 small">
                                    {errors.email_id}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className={`${candidateData.entrY_FORM !== "EX_REGULAR"
                    ? "col-lg-9"
                    : "col-md-12"
                    } col-md-12 mb-4 stretch-card`}
                >
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>
                                <select
                                  disabled
                                  class="form-select form-control valid"
                                  id="category_choice"
                                  name="category_choice"
                                  value={formData.category_choice}
                                  onChange={handleChange}
                                >
                                  <option value="">Choose Category</option>
                                  <option value="REGULAR">REGULAR </option>
                                  <option value="PRIVATE">PRIVATE </option>
                                  <option value="EX-REGULAR">
                                    EX-REGULAR{" "}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.board_name}
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div className="form-group mb-3">
                                <label>
                                  Stream{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <select
                                  className={`form-select form-control-sm  ${errors.stream ? "is-invalid" : ""
                                    }`}
                                  name="stream"
                                  id="stream"
                                  value={formData.stream}
                                  // disabled={isPreviewed || exregularornot}
                                  disabled
                                  onChange={(e) => {
                                    const selectedStream = e.target.value;
                                    setFormData({
                                      ...formData,
                                      stream: selectedStream,
                                    });
                                    if (
                                      selectedStream === "SCIENCE" ||
                                      selectedStream === "COMMERCE"
                                    ) {
                                      handleSetCompulsorySubjects(
                                        selectedStream,
                                      );
                                    } else {
                                      handleArtsSubjects();
                                    }
                                  }}
                                >
                                  <option value="">Choose Stream</option>

                                  {(formData.category_choice === "REGULAR" ||
                                    formData.category_choice ===
                                    "EX-REGULAR") && (
                                      <option value="SCIENCE">SCIENCE</option>
                                    )}
                                  <option value="COMMERCE">COMMERCE</option>
                                  <option value="ARTS">ARTS</option>
                                </select>
                                {errors.stream && (
                                  <div className="text-danger mt-1 small">
                                    {errors.stream}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {formData.stream && (
                            <div class="row">
                              <div class="col-md-12 mb-3">
                                <h4>Core Subjects</h4>
                                <hr />
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Core Language{" "}
                                        {/* {candidateData.entrY_FORM !=
                                          "EX_REGULAR" && ( */}
                                        <span class="text-danger">*</span>
                                        {/* )} */}
                                      </label>
                                      <select
                                        id="coresubject"
                                        className={`form-select  ${errors.coresubject ? "is-invalid" : ""
                                          }`}
                                        disabled={isPreviewed}
                                        name="coresubject"
                                        value={formData.coresubject || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            coresubject: selectedText,
                                          }));
                                          const selectedValue = e.target.value;
                                          if (
                                            selectedValue === "ENA" ||
                                            selectedValue === "HNA"
                                          ) {
                                            setFormData((prev) => ({
                                              ...prev,
                                              matribhasa: "",
                                            }));
                                            setSelectedSubjectNames((prev) => ({
                                              ...prev,
                                              matribhasa: "",
                                            }));
                                          }
                                        }}
                                      >
                                        <option value="">Choose Subject</option>
                                        {coresubject
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.matribhasa,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames,
                                              );
                                            return (
                                              subject.subjecT_ID ===
                                              formData.coresubject ||
                                              (!selectedIds.includes(
                                                subject.subjecT_ID,
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME,
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.coresubject && (
                                        <div className="text-danger mt-1 small">
                                          {errors.coresubject}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>
                                        Matri Bhasa{" "}
                                        {/* {formData.coresubject === "HNB" && ( */}
                                        <span class="text-danger">*</span>
                                        {/* )} */}
                                      </label>
                                      <select
                                        id="matribhasa"
                                        className={`form-select  ${errors.matribhasa ? "is-invalid" : ""
                                          }`}
                                        name="matribhasa"
                                        value={formData.matribhasa || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const selectedText =
                                            e.target.options[
                                              e.target.selectedIndex
                                            ].text;
                                          setSelectedSubjectNames((prev) => ({
                                            ...prev,
                                            matribhasa: selectedText,
                                          }));
                                        }}
                                        disabled={
                                          formData.coresubject === "ENA" ||
                                          formData.coresubject === "HNA" ||
                                          isPreviewed ||
                                          !formData.coresubject
                                        }
                                      >
                                        <option value="">Choose Subject</option>
                                        {matribhasa
                                          .filter((subject) => {
                                            const selectedIds = [
                                              formData.coresubject,
                                              formData.compulsory_one,
                                              formData.compulsory_two,
                                              formData.additionalsubject,
                                              selectedArtsSubjects.arts_optional_one,
                                              selectedArtsSubjects.arts_optional_two,
                                              selectedArtsSubjects.arts_optional_three,
                                              optional1,
                                              optional2,
                                              artselective,
                                            ];
                                            const selectedNames =
                                              Object.values(
                                                selectedSubjectNames,
                                              );
                                            return (
                                              subject.subjecT_ID ===
                                              formData.matribhasa || // ✅ Keep current selection
                                              (!selectedIds.includes(
                                                subject.subjecT_ID,
                                              ) &&
                                                !selectedNames.includes(
                                                  subject.subjecT_NAME,
                                                ))
                                            );
                                          })
                                          .map((subject) => (
                                            <option
                                              key={subject.subjecT_ID}
                                              value={subject.subjecT_ID}
                                            >
                                              {subject.subjecT_NAME}
                                            </option>
                                          ))}
                                      </select>
                                      {errors.matribhasa && (
                                        <div className="text-danger mt-1 small">
                                          {errors.matribhasa}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {formData.stream === "SCIENCE" && (
                                <>
                                  <div
                                    class="col-md-12 mb-3"
                                    id="science_paper2"
                                  >
                                    <h4>Compulsory Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 1{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsoryonename}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsorytwoname}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12 mb-3"
                                    id="science_paper3"
                                  >
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 1{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            className={`form-select ${errors.sc_optional_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed}
                                            id="sc_optional_one"
                                            name="sc_optional_one"
                                            value={optional1}
                                            onChange={(e) => {
                                              setOptional1(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional1: selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional2 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional1
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove STA here
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is STA, remove MAT here
                                                  if (
                                                    (optional2 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove CAE
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is CAE, remove MAT
                                                  if (
                                                    (optional2 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional1 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${errors.sc_optional_two
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="sc_optional_two"
                                            name="sc_optional_two"
                                            value={optional2}
                                            onChange={(e) => {
                                              setOptional2(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional2: selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional2
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional2 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12"
                                    id="science_additional"
                                  >
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        artselective &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                    "MAT" ||
                                                    arts_optional_two ===
                                                    "MAT" ||
                                                    arts_optional_three ===
                                                    "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "MAT" ||
                                                      subject.subjecT_ID ===
                                                      "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                    "STA" ||
                                                    arts_optional_two ===
                                                    "STA" ||
                                                    arts_optional_three ===
                                                    "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "STA" ||
                                                      subject.subjecT_ID ===
                                                      "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "COMMERCE" && (
                                <>
                                  <div
                                    class="col-md-12 mb-3"
                                    id="commerce_paper2"
                                  >
                                    <h4>Compulsory Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 1{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsoryonename}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Compulsory 2{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={compulsorytwoname}
                                            disabled
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12 mb-3"
                                    id="commerce_paper3"
                                  >
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 1{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            className={`form-select ${errors.sc_optional_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed}
                                            id="sc_optional_one"
                                            name="sc_optional_one"
                                            value={optional1}
                                            onChange={(e) => {
                                              setOptional1(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional1: selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional2 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional1
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove STA here
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is STA, remove MAT here
                                                  if (
                                                    (optional2 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  // If Optional 2 or Additional subject is MAT, remove CAE
                                                  if (
                                                    (optional2 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  // If Optional 2 or Additional subject is CAE, remove MAT
                                                  if (
                                                    (optional2 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional1 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${errors.sc_optional_two
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="sc_optional_two"
                                            name="sc_optional_two"
                                            value={optional2}
                                            onChange={(e) => {
                                              setOptional2(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              // Update name state
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  optional2: selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  optional2
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }

                                                // ✅ Science stream condition
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      formData.additionalsubject ===
                                                      "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream condition
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      formData.additionalsubject ===
                                                      "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      formData.additionalsubject ===
                                                      "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow only unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  optional2 ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.sc_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.sc_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="col-md-12"
                                    id="commerce_additional"
                                  >
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        artselective &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                    "MAT" ||
                                                    arts_optional_two ===
                                                    "MAT" ||
                                                    arts_optional_three ===
                                                    "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "MAT" ||
                                                      subject.subjecT_ID ===
                                                      "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                    "STA" ||
                                                    arts_optional_two ===
                                                    "STA" ||
                                                    arts_optional_three ===
                                                    "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "STA" ||
                                                      subject.subjecT_ID ===
                                                      "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {formData.stream === "ARTS" && (
                                <>
                                  <div class="col-md-12 mb-3" id="arts_paper2">
                                    <h4>Elective Subject</h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Elective Language
                                            {/* {candidateData.entrY_FORM !=
                                              "EX_REGULAR" && ( */}
                                            <span class="text-danger">*</span>
                                            {/* )} */}
                                          </label>
                                          <select
                                            className={`form-select ${errors.arts_elective_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed}
                                            id="arts_elective_one"
                                            name="arts_elective_one"
                                            value={artselective}
                                            onChange={(e) => {
                                              setArtselective(e.target.value);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  artselective: selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {electivefiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected =
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (formData.additionalsubject &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        formData.additionalsubject &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  artselective
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }
                                                return (
                                                  subject.subjecT_ID ===
                                                  artselective ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.arts_elective_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_elective_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12 mb-3" id="arts_paper3">
                                    <h4>Optional Subjects</h4>
                                    <hr />

                                    <div class="row">
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 1
                                            {/* {candidateData.entrY_FORM !=
                                              "EX_REGULAR" && ( */}
                                            <span class="text-danger">*</span>
                                            {/* )} */}
                                          </label>
                                          <select
                                            className={`form-select ${errors.arts_optional_one
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            disabled={isPreviewed}
                                            id="arts_optional_one"
                                            name="arts_optional_one"
                                            value={
                                              selectedArtsSubjects.arts_optional_one
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_one:
                                                    selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                // ✅ Vocational restriction: only one vocational allowed
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some((id) => {
                                                  if (!id) return false;
                                                  return (
                                                    artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES",
                                                    ) ||
                                                    optionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES",
                                                    ) ||
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES",
                                                    )
                                                  );
                                                });

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  selectedArtsSubjects.arts_optional_one
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion for Arts
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                ];
                                                if (
                                                  artsOptionals.includes(
                                                    "MAT",
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA",
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_one ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                          {errors.arts_optional_one && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_one}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 2{" "}
                                            {/* {candidateData.entrY_FORM !=
                                              "EX_REGULAR" && ( */}
                                            <span class="text-danger">*</span>
                                            {/* )} */}
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${errors.arts_optional_two
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="arts_optional_two"
                                            name="arts_optional_two"
                                            value={
                                              selectedArtsSubjects.arts_optional_two
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_two:
                                                    selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some(
                                                  (id) =>
                                                    id &&
                                                    (artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES",
                                                    ) ||
                                                      optionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational ===
                                                          "YES",
                                                      ) ||
                                                      additionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational ===
                                                          "YES",
                                                      )),
                                                );

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  selectedArtsSubjects.arts_optional_two
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_three,
                                                ].filter(Boolean);

                                                if (
                                                  artsOptionals.includes(
                                                    "MAT",
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA",
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                return (
                                                  subject.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_two ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.arts_optional_two && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_two}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group mb-3">
                                          <label>
                                            Optional 3{" "}
                                            {/* {candidateData.entrY_FORM !=
                                              "EX_REGULAR" && ( */}
                                            <span class="text-danger">*</span>
                                            {/* )} */}
                                          </label>
                                          <select
                                            disabled={isPreviewed}
                                            className={`form-select ${errors.arts_optional_three
                                              ? "is-invalid"
                                              : ""
                                              }`}
                                            id="arts_optional_three"
                                            name="arts_optional_three"
                                            value={
                                              selectedArtsSubjects.arts_optional_three
                                            }
                                            onChange={(e) => {
                                              handleArtsOptionalChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;
                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  arts_optional_three:
                                                    selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {optionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  formData.additionalsubject,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];
                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                // ✅ Vocational restriction
                                                const vocationalSelected = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  artselective,
                                                  formData.additionalsubject,
                                                ].some(
                                                  (id) =>
                                                    id &&
                                                    (artsSubjects.find(
                                                      (s) =>
                                                        s.subjecT_ID === id &&
                                                        s.vocational === "YES",
                                                    ) ||
                                                      optionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational ===
                                                          "YES",
                                                      ) ||
                                                      additionalfiltersubj.find(
                                                        (s) =>
                                                          s.subjecT_ID === id &&
                                                          s.vocational ===
                                                          "YES",
                                                      )),
                                                );

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  selectedArtsSubjects.arts_optional_three
                                                ) {
                                                  return false;
                                                }

                                                // ✅ MAT/STA exclusion
                                                const artsOptionals = [
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                ].filter(Boolean);

                                                if (
                                                  artsOptionals.includes(
                                                    "MAT",
                                                  ) &&
                                                  subject.subjecT_ID === "STA"
                                                )
                                                  return false;
                                                if (
                                                  artsOptionals.includes(
                                                    "STA",
                                                  ) &&
                                                  subject.subjecT_ID === "MAT"
                                                )
                                                  return false;

                                                return (
                                                  subject.subjecT_ID ===
                                                  selectedArtsSubjects.arts_optional_three ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>

                                          {errors.arts_optional_three && (
                                            <div className="text-danger mt-1 small">
                                              {errors.arts_optional_three}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12" id="arts_additional">
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div className="col-md-4 mb-2">
                                        <div className="form-group mb-3">
                                          <select
                                            disabled={isPreviewed}
                                            className="form-select"
                                            id="additionalsubject"
                                            name="additionalsubject"
                                            value={
                                              formData.additionalsubject || ""
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              const selectedText =
                                                e.target.options[
                                                  e.target.selectedIndex
                                                ].text;

                                              setSelectedSubjectNames(
                                                (prev) => ({
                                                  ...prev,
                                                  additionalsubject:
                                                    selectedText,
                                                }),
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Choose Subject
                                            </option>
                                            {additionalfiltersubj
                                              .filter((subject) => {
                                                const selectedIds = [
                                                  formData.coresubject,
                                                  formData.matribhasa,
                                                  formData.compulsory_one,
                                                  formData.compulsory_two,
                                                  selectedArtsSubjects.arts_optional_one,
                                                  selectedArtsSubjects.arts_optional_two,
                                                  selectedArtsSubjects.arts_optional_three,
                                                  optional1,
                                                  optional2,
                                                  artselective,
                                                ];

                                                const selectedNames =
                                                  Object.values(
                                                    selectedSubjectNames,
                                                  );

                                                const vocationalSelected =
                                                  (optional1 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional1 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (optional2 &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        optional2 &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_one &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_one &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_two &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_two &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (selectedArtsSubjects.arts_optional_three &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        selectedArtsSubjects.arts_optional_three &&
                                                        s.vocational === "YES",
                                                    )) ||
                                                  (artselective &&
                                                    additionalfiltersubj.find(
                                                      (s) =>
                                                        s.subjecT_ID ===
                                                        artselective &&
                                                        s.vocational === "YES",
                                                    ));

                                                if (
                                                  vocationalSelected &&
                                                  subject.vocational ===
                                                  "YES" &&
                                                  subject.subjecT_ID !==
                                                  formData.additionalsubject
                                                ) {
                                                  return false; // hide all vocational except the one already chosen
                                                }
                                                // ✅ Language-based restrictions
                                                if (
                                                  formData.coresubject ===
                                                  "HNA" &&
                                                  subject.subjecT_ID === "HIN"
                                                ) {
                                                  return false;
                                                }
                                                if (
                                                  formData.coresubject ===
                                                  "ENA" &&
                                                  (subject.subjecT_ID ===
                                                    "ENG" ||
                                                    subject.subjecT_ID ===
                                                    "FEN")
                                                ) {
                                                  return false;
                                                }

                                                // ✅ Science stream restrictions
                                                if (
                                                  formData.stream === "SCIENCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "STA"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "STA" ||
                                                      optional2 === "STA") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Commerce stream restrictions
                                                if (
                                                  formData.stream === "COMMERCE"
                                                ) {
                                                  if (
                                                    (optional1 === "MAT" ||
                                                      optional2 === "MAT") &&
                                                    subject.subjecT_ID === "CAE"
                                                  ) {
                                                    return false;
                                                  }
                                                  if (
                                                    (optional1 === "CAE" ||
                                                      optional2 === "CAE") &&
                                                    subject.subjecT_ID === "MAT"
                                                  ) {
                                                    return false;
                                                  }
                                                }

                                                // ✅ Arts stream MAT/STA restrictions
                                                if (
                                                  formData.stream === "ARTS"
                                                ) {
                                                  const {
                                                    arts_optional_one,
                                                    arts_optional_two,
                                                    arts_optional_three,
                                                  } = selectedArtsSubjects;

                                                  // If MAT selected anywhere, remove both MAT & STA
                                                  if (
                                                    arts_optional_one ===
                                                    "MAT" ||
                                                    arts_optional_two ===
                                                    "MAT" ||
                                                    arts_optional_three ===
                                                    "MAT"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "MAT" ||
                                                      subject.subjecT_ID ===
                                                      "STA"
                                                    ) {
                                                      return false;
                                                    }
                                                  }

                                                  // If STA selected anywhere, remove both STA & MAT
                                                  if (
                                                    arts_optional_one ===
                                                    "STA" ||
                                                    arts_optional_two ===
                                                    "STA" ||
                                                    arts_optional_three ===
                                                    "STA"
                                                  ) {
                                                    if (
                                                      subject.subjecT_ID ===
                                                      "STA" ||
                                                      subject.subjecT_ID ===
                                                      "MAT"
                                                    ) {
                                                      return false;
                                                    }
                                                  }
                                                }

                                                // ✅ Keep current selection OR allow unselected subjects
                                                return (
                                                  subject.subjecT_ID ===
                                                  formData.additionalsubject ||
                                                  (!selectedIds.includes(
                                                    subject.subjecT_ID,
                                                  ) &&
                                                    !selectedNames.includes(
                                                      subject.subjecT_NAME,
                                                    ))
                                                );
                                              })
                                              .map((subject) => (
                                                <option
                                                  key={subject.subjecT_ID}
                                                  value={subject.subjecT_ID}
                                                >
                                                  {subject.subjecT_NAME}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {candidateData.entrY_FORM != "EX_REGULAR" && (
                  <div class="col-lg-3 col-m-12 mb-4 stretch-card">
                    <div class="card other-details">
                      <div class="card-header card-green">
                        <h4 class="mb-0 p-2">Other Details</h4>
                      </div>
                      <div class="card-body">
                        {/* <div class="form-group mb-3">
                          <label>
                            Permanent Education Number (PEN){" "}
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            maxLength="14"
                            type="text"
                            id="pen_no"
                            name="pen_no"
                            className={`form-control form-control-sm ${
                              errors.pen_no ? "is-invalid" : ""
                            }`}
                            placeholder="Enter PEN No."
                            value={formData.pen_no}
                            onChange={handleChange}
                            onBlur={handlePenBlur}
                            disabled={isPreviewed}
                            inputMode="numeric"
                            pattern="\d*"
                          />

                          {errors.pen_no && (
                            <div className="text-danger mt-1 small">
                              {errors.pen_no}
                            </div>
                          )}
                        </div> */}
                        <div class="form-group mb-3">
                          <label>APAAR ID</label>
                          <input
                            maxlength="12"
                            type="text"
                            id="apaar_id"
                            name="apaar_id"
                            className={`form-control form-control-sm ${errors.apaar_id ? "is-invalid" : ""
                              }`}
                            placeholder="Enter APAAR ID"
                            value={formData.apaar_id}
                            onChange={(e) => {
                              const onlyNums = e.target.value.replace(
                                /\D/g,
                                "",
                              );
                              handleChange({
                                target: { name: "apaar_id", value: onlyNums },
                              });
                            }}
                            // onBlur={handleApaarBlur}
                            disabled={isPreviewed || exregularornot}
                          />
                          {errors.apaar_id && (
                            <div className="text-danger mt-1 small">
                              {errors.apaar_id}
                            </div>
                          )}
                        </div>
                        {formData.category_choice === "REGULAR" && (
                          <>
                            <div class="form-group mb-3">
                              <label>
                                Section <span class="text-danger">*</span>
                              </label>
                              <select
                                className={`form-select form-control-sm ${errors.section_val ? "is-invalid" : ""
                                  }`}
                                id="section_val"
                                name="section_val"
                                value={formData.section_val}
                                onChange={handleChange}
                                disabled={isPreviewed || exregularornot}
                              >
                                <option value="">Choose Section</option>
                                {[
                                  "A",
                                  "B",
                                  "C",
                                  "D",
                                  "E",
                                  "F",
                                  "G",
                                  "H",
                                  "I",
                                  "J",
                                  "K",
                                  "L",
                                  "M",
                                  "N",
                                  "O",
                                  "P",
                                  "Q",
                                  "R",
                                  "S",
                                  "T",
                                  "U",
                                  "V",
                                  "W",
                                  "X",
                                  "Y",
                                  "Z",
                                ].map((sec) => (
                                  <option key={sec} value={sec}>
                                    {sec}
                                  </option>
                                ))}
                              </select>
                              {errors.section_val && (
                                <div className="text-danger mt-1 small">
                                  {errors.section_val}
                                </div>
                              )}
                            </div>

                            <div class="form-group  mb-3">
                              <label>Class Roll No.</label>
                              <input
                                type="text"
                                id="clasS_ROLL_NO"
                                maxLength="3"
                                name="clasS_ROLL_NO"
                                className="form-control form-control-sm"
                                placeholder="Enter Exam Roll No."
                                value={formData.clasS_ROLL_NO || ""}
                                onChange={handleChange}
                                disabled={isPreviewed || exregularornot}
                                onBlur={handleRollBlur}
                              />

                              {/* {errors.clasS_ROLL_NO && (
                          <div className="text-danger mt-1 small">
                            {errors.clasS_ROLL_NO}
                          </div>
                        )} */}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div class="col-lg-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Uploaded Documents</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div className="col-md-3">
                          <div>
                            <h4 style={{ textAlign: "center" }}>Photograph</h4>
                          </div>
                          <div
                            style={{
                              width: "98%",
                              padding: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className="file-upload"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                          >
                            <div className="file-select2">
                              <div className="imagePreview2" id="photograph">
                                {(photoBase64 || photourl) && (
                                  <img
                                    src={photoBase64 || photourl}
                                    alt="Preview"
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                )}
                              </div>
                              {!isPreviewed && (
                                <button className="btn btn-secondary btn-sm file_btn">
                                  Choose File
                                </button>
                              )}
                              <div
                                className="file-select-name2"
                                id="photograph_name"
                              >
                                {photoName
                                  ? photoName.length > 60
                                    ? `${photoName.slice(0, 60)}...`
                                    : photoName
                                  : "No File Chosen"}
                              </div>
                              {!isPreviewed && (
                                <input
                                  type="file"
                                  ref={photographRef}
                                  className="profileimg form-control"
                                  id="upload_photograph"
                                  accept=".JPG,.JPEG"
                                  // onChange={(e) => handleChange2(e, "photograph")}
                                  onChange={(e) => handlePhotoChange(e)}
                                  style={{
                                    position: "absolute",
                                    opacity: 0,
                                    left: 0,
                                    bottom: 0,
                                    top: 0,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div>
                            <h4 style={{ textAlign: "center" }}>Signature</h4>
                          </div>
                          <div
                            style={{
                              width: "98%",
                              padding: "10px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                            className="file-upload"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                          >
                            <div className="file-select2">
                              <div className="imagePreview2" id="signature">
                                {(signBase64 || signurl) && (
                                  <img
                                    src={signBase64 || signurl}
                                    alt="Preview"
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      objectFit: "contain",
                                      borderRadius: "6px",
                                    }}
                                  />
                                )}
                              </div>
                              {!isPreviewed && (
                                <button className="btn btn-secondary btn-sm file_btn">
                                  Choose File
                                </button>
                              )}
                              <div
                                className="file-select-name2"
                                id="signature_name"
                              >
                                {signName
                                  ? signName.length > 60
                                    ? `${signName.slice(0, 60)}...`
                                    : signName
                                  : "No File Chosen"}
                              </div>
                              {!isPreviewed && (
                                <input
                                  type="file"
                                  ref={signatureRef}
                                  className="profileimg form-control"
                                  id="upload_signature"
                                  accept=".JPG,.JPEG"
                                  // onChange={(e) => handleChange2(e, "photograph")}
                                  onChange={(e) =>
                                    handleChange2(e, "signature")
                                  }
                                  style={{
                                    position: "absolute",
                                    opacity: 0,
                                    left: 0,
                                    bottom: 0,
                                    top: 0,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        {formData.caste_val !== "CS_001" &&
                          formData.caste_val != "" &&
                          formData.caste_val !== null && (
                            <div className="col-md-3">
                              <div>
                                <h4 style={{ textAlign: "center" }}>
                                  Caste Certificate
                                </h4>
                              </div>
                              <div
                                style={{
                                  width: "98%",
                                  padding: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                className="file-upload"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                              >
                                <div className="file-select2">
                                  <div className="imagePreview2" id="caste">
                                    {casteName && (
                                      <a
                                        href={
                                          isPreviewed
                                            ? undefined
                                            : casteurl || casteBase64
                                        }
                                      >
                                        <FaRegFilePdf
                                          style={{
                                            fontSize: "70px",
                                            marginTop: "50px",
                                          }}
                                          className="text-danger"
                                        />
                                      </a>
                                    )}
                                  </div>
                                  {!isPreviewed && (
                                    <button className="btn btn-secondary btn-sm file_btn">
                                      Choose File
                                    </button>
                                  )}
                                  <div
                                    className="file-select-name2"
                                    id="caste_name"
                                  >
                                    {casteName
                                      ? casteName.length > 60
                                        ? `${casteName.slice(0, 60)}...`
                                        : casteName
                                      : "No File Chosen"}
                                  </div>
                                  {!isPreviewed && (
                                    <input
                                      type="file"
                                      ref={casteRef}
                                      className="profileimg form-control"
                                      id="upload_caste"
                                      accept=".PDF"
                                      // onChange={(e) => handleChange2(e, "photograph")}
                                      onChange={(e) =>
                                        handleChange2(e, "caste")
                                      }
                                      style={{
                                        position: "absolute",
                                        opacity: 0,
                                        left: 0,
                                        bottom: "40px",
                                        top: 0,
                                      }}
                                    />
                                  )}
                                  {errors.caste_certificate_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.caste_certificate_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* {isPreviewed && (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <a
                                  href={`${casteurl || casteBase64}`}
                                  target="_blank"
                                  className="btn btn-primary btn-sm file_btn"
                                >
                                  <i className="fa fa-download"></i> Download
                                  File
                                </a>
                              </div>
                            )} */}
                            </div>
                          )}

                        {formData.divyang_val !== "DIV_001" &&
                          formData.divyang_val !== null &&
                          formData.divyang_val !== "" && (
                            <div className="col-md-3">
                              <div>
                                <h4 style={{ textAlign: "center" }}>
                                  Divyang Certificate
                                </h4>
                              </div>
                              <div
                                style={{
                                  width: "98%",
                                  padding: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                                className="file-upload"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-bs-original-title="Document Format : JPG<br>Min Size : 10 KB<br>Max Size : 40KB"
                              >
                                <div className="file-select2">
                                  <div className="imagePreview2" id="divyang">
                                    {divyangName && (
                                      <a
                                        href={
                                          isPreviewed
                                            ? undefined
                                            : divyangurl || divyangBase64
                                        }
                                      // target="_blank"
                                      // rel="noreferrer"
                                      >
                                        <FaRegFilePdf
                                          style={{
                                            fontSize: "70px",
                                            marginTop: "50px",
                                          }}
                                          className="text-danger"
                                        />
                                      </a>
                                    )}
                                  </div>
                                  {!isPreviewed && (
                                    <button className="btn btn-secondary btn-sm file_btn">
                                      Choose File
                                    </button>
                                  )}
                                  <div
                                    className="file-select-name2"
                                    id="divyang_name"
                                  >
                                    {divyangName
                                      ? divyangName.length > 60
                                        ? `${divyangName.slice(0, 60)}...`
                                        : divyangName
                                      : "No File Chosen"}
                                  </div>
                                  {!isPreviewed && (
                                    <input
                                      type="file"
                                      ref={divyangRef}
                                      className="profileimg form-control"
                                      id="upload_divyang"
                                      accept=".PDF"
                                      // onChange={(e) => handleChange2(e, "photograph")}
                                      onChange={(e) =>
                                        handleChange2(e, "divyang")
                                      }
                                      style={{
                                        position: "absolute",
                                        opacity: 0,
                                        left: 0,
                                        bottom: "40px",
                                        top: 0,
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                              {/* {isPreviewed && (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm file_btn"
                                  onClick={() => {
                                    const pdfToOpen = divyangurl
                                      ? divyangurl
                                      : `data:application/pdf;base64,${divyangBase64}`;
                                    window.open(pdfToOpen, "_blank");
                                  }}
                                >
                                  <i className="fa fa-download"></i> Download
                                  File
                                </button>
                              </div>
                            )} */}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      {showCropper && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "600px",
              margin: "100px auto",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Cropper
              src={cropperImage}
              style={{ height: 400, width: "100%" }}
              aspectRatio={3 / 4}
              guides={true}
              ref={cropperRef}
            />
            <div style={{ marginTop: "10px", textAlign: "right" }}>
              <button className="btn btn-primary" onClick={handleCropConfirm}>
                Crop & Validate
              </button>
              <button
                className="btn btn-secondary"
                style={{ marginLeft: "10px" }}
                onClick={handleCropCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default StudentCorrectionPageXI;
